export default "__VITE_ASSET__kHgNsz_B__"